import React from 'react';
import './App.css';

function App() {
  return (
    <main className="coming-soon">
      <div className="brand" aria-label="StoneCord">
        StoneCord<span>.</span>
      </div>
      <p className="eyebrow">COMING SOON</p>
      <h1>100% pure ube powder.</h1>
      <p className="about">
        StoneCord LLC is a California importer and distributor of Philippine food
        ingredients, starting with 100% pure ube (purple yam) powder. We are not
        a broker or a dealer. The ube is grown on our family farms in the
        Philippines and processed to our specifications, so our supply is steady
        and traceable from field to pouch. We sell wholesale to bakeries, cafés,
        ice-cream makers, food manufacturers and distributors.
      </p>
      <a className="email" href="mailto:cs@stonecord.com">
        cs@stonecord.com
      </a>
    </main>
  );
}

export default App;